<script setup>

import { computed, defineEmits, defineProps } from 'vue'
import { useStore } from 'vuex'


const store = useStore()
const emit = defineEmits(['callback'])

const props = defineProps({
  folder: Object,
})

const reactionEnum = computed(() => store.getters['projects/getProjectReactionEnum'])

function makeOrUpdateReact(comment) {
  store.dispatch('projects/updateReactForProject', {id: props.folder.id, comment } )
      .then(res => {
        emit('callback')
      })
      .catch(() => {})
      .finally(() => {})
}

</script>

<template>
  <div
      class="card d-flex gap-3 flex-row align-items-center shadow rounded-2 p-2">
    <i v-for="(reaction, index) in reactionEnum"
       @click.prevent="makeOrUpdateReact(reaction.value)"
       :key="index"
       class="fa cursor-pointer hovering-zoom"
       v-html="reaction.value"
       style="font-size: 1.2rem"
    ></i>
  </div>
</template>

<style scoped>

.hovering-zoom:hover {
  transform: scale(1.2);
}

</style>